import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Moment from 'react-moment';
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help';
import { donationTypeExtraction } from '../../../libs/services';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');
var report = require('../../generics/report_head');

class SerologyReport extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.getConvokePlace = this.getConvokePlace.bind(this);

		this.setTable = this.setTable.bind(this);

		this.state = {
			health_facilities_id:"",
			health_facilities: [],

			extraction_type_id:"all",
			extraction_type:[],

			start_date 	: "",
			end_date 	: "",
			start_folio:"",
			end_folio:"",

			convoke_places:[],
			convoke_places_id:"all",

			table_list:[],
			listado:[],

			change_check: false,

			//test datatable to export
			columns:[
				{title:'No.'},
				{title:'Fecha'},
				{title:'Donante'},
				{title:'No. Unidad'},
				{title:'Hospital'},
				{title:'Grupo & RH'},
				{title:'Tipo Donación'},
				{title:'Tipo Extracción'}
				/*{title:'ANTI-HBC TOTAL'},
				{title:'CHAGAS'},
				{title:'HEP B'},
				{title:'HEP C'},				
				{title:'HIV'},
				{title:'SIFILIS'}*/
			],
			filename:"Reporte Serologia",
			search_by:"donations",
			search_type:"date",
			count:"",

			result:"all",
			extraction_type_name:"",
			convoke_places_name:"",
			results_name:"",

			donation_type_id:"all",
			donations_type:[],

			totals:[],
			date_hour:"",
			medical:"",
			pdf_sero_rep:""
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	async componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PDF_SERO_REP',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      pdf_sero_rep: response.value
		    });
		})


		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		})

		this.getConvokePlace();

		let aux_resp = await donationTypeExtraction("no_cells");
        if(aux_resp !== undefined){
            this.setState({
                extraction_type: aux_resp
            });
        }

		fetch(Config.default.apiGateway.URL+'donation_type/actives', {
 			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
 		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					donations_type: response
				});
			}
		});

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		this.$el = $(this.el);
		var fechas = "Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" Al: "+moment(this.state.end_date).format("DD/MM/YYYY") 
		
		var btnPdf = {};

		if(this.state.pdf_sero_rep === 'REPORTE'){
			btnPdf = {
				extend: 'pdf',
				title: this.state.filename,
				orientation:'landscape',
				customize: (doc)=> { 
					doc.content.unshift({
						image: this.props.header_document,
						alignment:'center',
						width:this.props.w_head
					});
					doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
					doc.content.splice(3, 0, {
						columns:[
							this.state.convoke_places_id !== "all" ?
								{text: 'Lugar de Colecta', width:'12%', fontSize:6.5}
							: {text:"", width:0},
							this.state.convoke_places_id !== "all" ?
								{text: this.state.convoke_places_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
							: {text:"", width:0},

							this.state.extraction_type_id !== "all" ?
								{text: 'Extracción', width:'8%', fontSize:6.5}
							: {text:"", width:0},
							this.state.extraction_type_id !== "all" ?
								{text: this.state.extraction_type_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
							: {text:"", width:0},

							this.state.result !== "all" ?
								{text: 'Donación', width:'8%', fontSize:6.5}
							: {text:"", width:0},
							this.state.result !== "all" ?
								{text: this.state.results_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
							: {text:"", width:0}

						]
					});

					this.state.totals.map((r, i)=>{
						var obj = {}
						
						r.results.map((g, j)=>(
							obj = {
								text: r.test+': \t\t'+(g.name === "" ? 'Sin Grupo ' : g.name)+'\t - \t'+g.tot+
										(j !== r.results.length - 1 ? ' / ' : ''), 
								margin: i=== 0 ? [0,15,0,0] : [0,0,0,0],

							}
						))
						
						doc.content.push(obj);
					})
					
					doc.content.push(
						{text:'Total: \t\t'+this.state.count,margin:[5,15,0,30]}
					)


					doc.content.push(
						{columns:[
							{fontSize:7,
							width:'50%',
							alignment:'center',
							text: '_____________________________________________'},
							{fontSize:7,
							width:'50%',
							alignment:'center',
							text: '_____________________________________________'},
						]},
						{columns:[
							{fontSize:7,
							width:'50%',
							alignment:'center',
							text: '(Nombre y Firma)'},
							{fontSize:7,
							width:'50%',
							alignment:'center',
							text: '(Nombre y Firma)'},
						]},
						{columns:[
							{fontSize:7,
							width:'50%',
							alignment:'center',
							text: 'PROCESO Y VALIDO'},
							{fontSize:7,
							width:'50%',
							alignment:'center',
							text: 'QUIEN RECIBE'},
						]},
					)

					

					doc.styles.tableHeader.fontSize = 5;
					doc.defaultStyle.fontSize = 5; 

					doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
				} 
			};
		}else{
			btnPdf = {
				text:'PDF',
				action: (e, dt, node, config)=>{
					var obj = {
						convoke_places_id: this.state.convoke_places_id,
						start_date: this.state.start_date,
						end_date: this.state.end_date,
						start_folio: this.state.start_folio,
						end_folio: this.state.end_folio,
						extraction_type_id: this.state.extraction_type_id,
						donation_type_id: this.state.donation_type_id,
						result: this.state.result,
						format:'serology',
						health_facilities_id:this.state.health_facilities_id,
						report:'PDF_SERO_REP'
					};

					this.props.printPdfReports(obj);
				}
			}
		}
	

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename,
                	messageBottom:()=>{
                		var results = '';
						this.state.totals.map((r, i)=>{
							r.results.map((g, i)=>(
								results += r.test+': '+(g.name === "" ? 'Sin Grupo ' : g.name)+'\t - \t'+g.tot+
										(i !== r.results.length - 1 ? ' / ' : '\n')
								
							))
						})

						return results+'\nTOTAL: \t\t'+this.state.count
						
                	}
            	},
            	btnPdf
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.dt-button').disable();
		}else {
			table.buttons('.dt-button').enable();
		}
	}

	handleChange(e){
		
		this.setState({
			[e.target.name]: e.target.value
		});
		

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

		if(e.target.name === 'health_facilities_id'){
			setTimeout(()=>{
				this.getConvokePlace();
				
			}, 500);
		}else if(e.target.name === 'convoke_places_id'){
			this.setState({
				convoke_places_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'extraction_type_id'){
			this.setState({
				extraction_type_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'result'){
			this.setState({
				results_name: e.target.options[e.target.selectedIndex].text
			})
		}
	}

	searching(){

		if(this.isValidForm()){
			if(this.dateCompare()){
				this.props.waiting.handleShow('Buscando...');

				var obj = {
					convoke_places_id: this.state.convoke_places_id,
					start_date: this.state.start_date,
					end_date: this.state.end_date,
					start_folio: this.state.start_folio,
					end_folio: this.state.end_folio,
					extraction_type_id: this.state.extraction_type_id,
					donation_type_id: this.state.donation_type_id,
					result: this.state.result,
					format:'serology',
					health_facilities_id:this.state.health_facilities_id
				}
				
				fetch(Config.default.apiGateway.URL+'reports/serology',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						var columns = [{title:'No.', width:'50px'},
							{title:'Fecha', width:'90px'},
							{title:'Donante', width:'250px'},
							{title:'No. Unidad', width:'100px'},
							{title:'Hospital', width:'200px'},
							{title:'Grupo & RH', width:'100px'},
							{title:'Tipo Donación', width:'100px'},
							{title:'Tipo Extracción', width:'100px'}];

						if(response.resp.length > 0){
							response.resp[0].results.map((r)=>{
								columns.push({title:r.name, width:'150px'});
							});
						}

						this.setState({listado: [], columns:columns});

						var list = [];
						response.resp.map((r, i)=>{
							var obj = [];
							obj.push(
								i+1,
								moment(r.serology_date).format('DD/MM/YYYY HH:mm'),
								r.donor_name,
								r.donation_number,
								r.center,
								r.group+
								(r.rh === 'POSITIVO' ? '+' : r.rh === 'NEGATIVO' ? '-' : ''),
								r.donation_type,
								r.extraction_type,
								/*r.brucella === 'POSITIVO' ? 'POS' : r.brucella === 'NEGATIVO' ? 'NEG' : r.brucella ,
								r.chagas === 'POSITIVO' ? 'POS' : r.chagas === 'NEGATIVO' ? 'NEG' : r.chagas,
								r.hepb === 'POSITIVO' ? 'POS' : r.hepb === 'NEGATIVO' ? 'NEG' : r.hepb,
								r.hepc === 'POSITIVO' ? 'POS' : r.hepc === 'NEGATIVO' ? 'NEG' : r.hepc,
								r.hiv === 'POSITIVO' ? 'POS' : r.hiv === 'NEGATIVO' ? 'NEG' : r.hiv,
								r.sifilis === 'POSITIVO' ? 'POS' : r.sifilis === 'NEGATIVO' ? 'NEG' : r.sifilis*/
							)

							r.results.map((rsl)=>{
								obj.push(
									rsl.value === 'POSITIVO' ? 'POS' : rsl.value === 'NEGATIVO' ? 'NEG' : rsl.value ,
								)
							})

							list.push(obj);
						});


						this.setState({
							listado: list,
							count: response.Count,
							totals: response.totals
						});

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
					
							
						this.props.waiting.handleClose();
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		
		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}

 	getConvokePlace(){
 		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
 	}

	render(){
		const {t} = this.props;
		const { selectedOption } = this.state;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Laboratorio ->
					{t('sidebar.nav.reports.serology_report')}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_serology_report"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span>
								</div>
								<div className="form-group">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Tipo de Busqueda</span>
									<select className="form-control" name="search_type" id="search_type"
										value={this.state.search_type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="date">Fecha</option>
										<option value="folio">Folio</option>
									</select>
								</div>
								{this.state.search_type === 'date' ?
									<div>
										<div className="form-group">
											<span className="span-min">Fecha Desde</span>
											<input type="date" className="form-control hour-input" name="start_date" id="start_date"
												value={this.state.start_date} onChange={this.handleChange} required />
										</div>
										<div className="form-group">
											<span className="span-min">Fecha Hasta</span>
											<input type="date" className="form-control hour-input" name="end_date" id="end_date"
												value={this.state.end_date} onChange={this.handleChange} required />
										</div>
									</div>
								: <div className="form-group">
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingLeft:"0"}}>
										<span className="span-min">Folio Desde</span>
										<input type="text" className="form-control"  name="start_folio" id="start_folio"
											value={this.state.start_folio} onChange={this.handleChange} />
									</div>
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingRight:"0"}}>
										<span className="span-min">Folio Hasta</span>
										<input type="text" className="form-control" name="end_folio" id="end_folio"
											value={this.state.end_folio} onChange={this.handleChange} />
									</div>
								</div>
								}
									
								<div className="form-group">
									<span className="span-min">Tipo de Extracción</span>
									<select className="form-control" name="extraction_type_id" id="extraction_type_id"
										value={this.state.extraction_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.extraction_type.map((don, i)=>{
											return <option key={i} value={don.id}>
												{don.donation_type_process}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Tipo de Donación</span>
									<select className="form-control"  name="donation_type_id" id="donation_type_id"
										value={this.state.donation_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.donations_type.map((d, i)=>{
											return <option key={i} value={d.donation_type.id}>
												{d.lookup_value}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Resultados</span>
									<select className="form-control" name="result" id="result"
										value={this.state.result} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="negative">NEGATIVOS</option>
										<option value="reactive">REACTIVOS</option>
									</select>
								</div>
							
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
										<span>
											{t('sidebar.nav.reports.serology_report')}
										</span>
									</div>
									<div className="col-xs-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>

									<div className="col-xs-12">
										{this.state.convoke_places_id !== 'all' && this.state.convoke_places_id !== ""?
											<span>
												Lugar de Colecta:  
												<b style={{marginLeft:"5px"}}>{this.state.convoke_places_name}</b>
											</span>	
										:null}

										{this.state.extraction_type_id !== 'all' && this.state.extraction_type_id !== ""?
											<span style={{marginLeft:"15px"}}>
												Extracción: 
												<b style={{marginLeft:"5px"}}>{this.state.extraction_type_name}</b>
											</span>	
										:null}

										{this.state.result !== 'all' && this.state.result !== "" ?
											<span style={{marginLeft:"15px"}}>
												Resultados:  
												<b style={{marginLeft:"5px"}}>{this.state.results_name}</b>
											</span>	
										:null}
									</div>
								</div>

								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="table-to-xls" 
											width="100%" ref={el => this.el = el}>
										</table>
									</div>

								</div>
								<div className="col-xs-12" style={{fontSize:"14px"}}>
									<label style={{margin:"0 5px"}}>TOTAL:</label>{' '+this.state.count}
								</div>

								{this.state.totals.map((r, i)=>(
									<div key={i} className="col-xs-12" style={{fontSize:"14px"}}>
										<label style={{margin:"0 5px"}}>{r.test+': '}</label>
										{r.results.map((g, i)=>(
											<span key={i} style={{marginLeft:'5px'}}>
												{(g.name === "" ? 'Sin Grupo ' : g.name)+'\t - \t'+g.tot+
												(i !== r.results.length - 1 ? ' / ' : '')} 
											</span>
										))}
									</div>
								))}
									

								
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (SerologyReport);